module.exports = __webpack_public_path__ + "c73f0e12e390a4fe9855fbdbedf650ef.svg";